module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-3c-1422a979f3a89c3a65bb5f81e6ea9992.png";